import { render, staticRenderFns } from "./StatusControls.vue?vue&type=template&id=c264d86c&"
import script from "./StatusControls.vue?vue&type=script&lang=ts&"
export * from "./StatusControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports